function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:none;stroke:#707070;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "prefix__order",
  transform: "translate(1.414 1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "prefix__Path_401",
  d: "M1.8 11.064L6.564 6.3l4.764 4.764",
  className: "prefix__cls-1",
  "data-name": "Path 401",
  transform: "translate(-1.8 -6.3)"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix__Path_402",
  d: "M22.941 13.7l-4.877 4.764L13.3 13.7",
  className: "prefix__cls-1",
  "data-name": "Path 402",
  transform: "translate(-.256 -5.306)"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix__Line_411",
  d: "M0 0L0 13.157",
  className: "prefix__cls-1",
  "data-name": "Line 411",
  transform: "translate(4.764)"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix__Line_412",
  d: "M0 13.157L0 0",
  className: "prefix__cls-1",
  "data-name": "Line 412",
  transform: "translate(17.808)"
}));

var SvgOrder = function SvgOrder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25.513,
    height: 15.157,
    viewBox: "0 0 25.513 15.157",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOrder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/order.35513bae.svg";
export { ForwardRef as ReactComponent };